import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import "./index.css";

/**
 * KGAI-Admin entry point.
 *
 * Minimal bootstrap: React Router for URL-based navigation (SPA mode via
 * wrangler's `not_found_handling: "single-page-application"`), TanStack
 * Query for server state (oRPC hooks will plug in once we port modules
 * from KGAI).
 */

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Mirror KGAI's defaults — admins expect the same responsiveness.
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
